export const SUCCESS_SUFFIX = '_SUCCESS';
export const ERROR_SUFFIX = '_FAIL';
export const CANCEL_SUFFIX = '_CANCEL';
